<!--
  - Copyright (c) 2023. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div>
    <div v-if="faIcon">
      <div class="cursor-pointer rounded-full w-10 h-10 relative"
           :class="`${color ? color : 'text-white'} ${backgroundColor ? backgroundColor : 'bg-secondary'} ${selected ? 'dark:bg-primary-100 dark:text-secondary-350 bg-primary text-white' : ''}`"
      >
        <i class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" :class="faIcon"></i>
      </div>
    </div>
    <div v-else>
      <!-- class="cursor-pointer px-6 py-2 border border-primary text-primary hover:bg-primary hover:text-secondary uppercase" -->
      <!-- class="cursor-pointer mt-3 inline-flex w-full justify-center rounded-md border border-secondary bg-white hover:bg-secondary hover:text-white px-4 py-2 text-secondary font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" -->
      <div
          class="button"
          :class="`${color ? color : 'text-secondary'} ${backgroundColor ? backgroundColor : 'bg-secondary'} ${selected ? 'dark:!bg-primary-100 dark:!text-secondary-350 !bg-primary !text-white' : ''}`"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonComponent",
  props: {
    faIcon: {
      required: false
    },
    color: {
      required: false
    },
    backgroundColor: {
      required: false
    },
    selected: {
      required: false
    }
  }
};
</script>

<style scoped>

</style>